export default __webpack_public_path__ + "images/0xd7ecf95cf7ef5256990beaf4ac895cd9e64cb947.png";